var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTomb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.533,32.866h-8.247v-7.443c0-3.014-2.452-5.466-5.466-5.466h-7.64c-3.014,0-5.467,2.452-5.467,5.466v7.443h-8.247 c-3.014,0-5.467,2.452-5.467,5.466v7.647c0,3.014,2.453,5.466,5.467,5.466h8.247v19.132c0,3.015,2.453,5.467,5.467,5.467h7.64 c3.014,0,5.466-2.452,5.466-5.467V51.445h8.247c3.015,0,5.467-2.452,5.467-5.466v-7.647C71,35.318,68.548,32.866,65.533,32.866z  M67,45.979c0,0.809-0.658,1.466-1.467,1.466H55.286c-1.104,0-2,0.896-2,2v21.132c0,0.809-0.657,1.467-1.466,1.467h-7.64 c-0.795,0-1.467-0.672-1.467-1.467V49.445c0-1.104-0.896-2-2-2H30.467c-0.809,0-1.467-0.658-1.467-1.466v-7.647 c0-0.809,0.658-1.466,1.467-1.466h10.247c1.104,0,2-0.896,2-2v-9.443c0-0.809,0.658-1.466,1.467-1.466h7.64 c0.809,0,1.466,0.658,1.466,1.466v9.443c0,1.104,0.896,2,2,2h10.247c0.809,0,1.467,0.658,1.467,1.466V45.979z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomb);
export default __webpack_public_path__ + "static/media/tomb.460bc88780e4385dae27a822ff87f396.svg";
export { ForwardRef as ReactComponent };